// extracted by mini-css-extract-plugin
export default {"button":"ResumeButton_button__wbGCb","light":"ResumeButton_light__VfwiH","dark":"ResumeButton_dark__9nfpS","collapsed":"ResumeButton_collapsed__YymE+"};